import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { useFormat } from "@/lib/format";
import { PageHeader, Empty } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const { t } = useTranslation();
  const fmt = useFormat();
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then(setLogs).catch(() => {}); }, []);

  return (
    <div className="animate-fade-up">
      <PageHeader subtitle={t("audit.subtitle")} title={t("audit.title")} />
      {logs.length === 0 ? <Empty title={t("audit.empty")} hint={t("audit.emptyHint")} /> : (
        <Card className="bg-card/60 divide-y divide-border">
          {logs.map((l) => (
            <div key={l.id} className="flex items-center gap-3 p-4" data-testid="audit-row">
              <ScrollText className="w-4 h-4 text-muted-foreground shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm">
                  <span className="text-primary capitalize">{l.action}</span> {l.entity}
                  <span className="text-muted-foreground"> · {l.user_email}</span>
                </div>
                <div className="text-xs text-muted-foreground">{fmt.dt(l.created_at)}</div>
              </div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
